export type SelectedGoalId =
  | 'rest_and_sleep_better'
  | 'feel_better_in_your_body'
  | 'make_movement_a_habit'
  | 'feel_calmer_under_stress'
  | 'find_your_focus'
  | 'nail_your_nutrition'
  | 'build_better_money_habits';

export const selectableGoals: SelectedGoalId[] = [
  'rest_and_sleep_better',
  'feel_better_in_your_body',
  'make_movement_a_habit',
  'feel_calmer_under_stress',
  'find_your_focus',
  'nail_your_nutrition',
  'build_better_money_habits',
];
